<template>
  <div class="skeleton layout align-center justify-center">
    <v-progress-circular indeterminate />
  </div>
</template>

<script>
export default {
  name: 'SkeletonComponent'
};
</script>

<style scoped>
.skeleton {
  width: 100%;
  height: 100%;
}
</style>
